import { CommandTemplate } from '../commandTemplate/commandTemplate';
import { HasCommands } from '../../services/command/command.service';

export class Label implements HasCommands {

  static ENTITY_TYPE: string = 'Label';

  id: string;
  externalId: string;
  name: string;
  scope: string;
  scopedName: string;
  color: string;
  description: string;
  commands: [CommandTemplate];

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.name = payload.name;
      this.scope = payload.scope;
      this.color = payload.color;
      this.description = payload.description;
      if (payload.commands) {
        this.commands = payload.commands.map((command: any) => new CommandTemplate(command));
      }
      this.scopedName = this.scope ? `${this.scope}::${this.name}` : this.name;
    }
  }

  getEntityId(): string {
    return this.id;
  }

  getCollectionRoute(): string {
    return '/settings/labels';
  }

  get text(): string {
    return this.name;
  }

  get entityType(): string {
    return Label.ENTITY_TYPE;
  }

  getEntityType(): string {
    return Label.ENTITY_TYPE;
  }

  static createLabels(result: Array<any>): Label[] {
    const labels = new Array<Label>();
    if (result) {
      result.map((label) => {
        labels.push(new Label(label));
      });
    }
    return labels;
  }
}
